/* eslint-disable react/jsx-no-duplicate-props */
import React, { Component } from 'react';
import { Form, Button, Modal, Tag, Tabs, message } from 'antd';
import styles from './index.less';

const { TabPane } = Tabs;

class SelectTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValue: [],
      groupData: [],
      tempValue: [],
      tempData: [],
      visible: false,
    };
  }

  componentDidMount() {
    const { checkedValue, groupData } = this.props;
    this.setState({
      checkedValue,
      groupData,
      tempValue: JSON.parse(JSON.stringify(checkedValue)),
      tempData: JSON.parse(JSON.stringify(groupData)),
    });
  }

  componentWillReceiveProps(nextprops) {
    this.setState({
      checkedValue: nextprops.checkedValue,
      groupData: nextprops.groupData,
      tempValue: JSON.parse(JSON.stringify(nextprops.checkedValue)),
      tempData: JSON.parse(JSON.stringify(nextprops.groupData)),
    });
  }

  componentWillUnmount() {
    this.setState({
      checkedValue: [],
      groupData: [],
      tempValue: [],
      tempData: [],
      visible: false,
    });
  }

  onChecked = (currentData, currentGroup) => {
    const { groupData } = this.state;

    const arr = [];
    groupData.forEach(item => {
      if (currentGroup.groupId === item.groupId) {
        item.list.forEach(tag => {
          if (currentData.labelId === tag.labelId) {
            tag.checked = !tag.checked;
          }
        });
      }
    });
    groupData.forEach(item => {
      item.list.forEach(tag => {
        if (tag.checked) {
          arr.push(tag);
        }
      });
    });

    this.setState({
      groupData,
      checkedValue: arr,
    });
  };

  handleOk = () => {
    const { groupData, checkedValue } = this.state;
    const { handleOk } = this.props;

    if (checkedValue.length > 10) {
      message.warning('最多可关联10个标签');
      return;
    }
    groupData.forEach(item => {
      item.list.forEach(tag => {
        tag.checked = false;
      });
    });
    this.setState({
      visible: false,
      groupData,
    });
    handleOk({
      checkedValue,
      groupData,
    });
  };

  handleCancel = () => {
    const { tempValue, tempData, groupData } = this.state;
    const { handleOk } = this.props;
    groupData.forEach(item => {
      item.list.forEach(tag => {
        tag.checked = false;
      });
    });
    this.setState({
      visible: false,
      groupData,
    });
    handleOk({
      checkedValue: tempValue,
      groupData: tempData,
    });
  };

  onClose = (currentData, e) => {
    e.preventDefault();
    const { groupData, checkedValue } = this.state;
    checkedValue.map((item, index) => {
      if (item.labelId === currentData.labelId) {
        checkedValue.splice(index, 1);
      }
    });

    groupData.forEach(item => {
      item.list.forEach(tag => {
        if (currentData.labelId === tag.labelId) {
          tag.checked = false;
        }
      });
    });
    this.setState({
      groupData,
      checkedValue,
    });
  };

  checkedLabel = (arr, id) => {
    let flag = false;
    arr.forEach(item => {
      if (item.labelId === id) {
        flag = true;
      }
    });
    return flag;
  };

  render() {
    const { visible, checkedValue = [], groupData = [] } = this.state;
    return (
      <div className={styles.selectTag}>
        {checkedValue.length > 0 ? (
          <div className="tag-result-wrap">
            <div className="tag-result-total">
              <div className="tag-select-title">已选标签</div>
              <div className="tag-option">
                <img
                  src="https://s.xiaoyuanhao.com/file/0cc0418f-1a69-4851-bf66-1a6d98f64689.svg"
                  alt=""
                />
                <div onClick={() => this.setState({ visible: true })}>修改</div>
              </div>
            </div>
            <div className="tag-result-detail-box">
              {checkedValue.map(tag => {
                return (
                  <div className="tag-item-checked" key={tag.labelId}>
                    {tag.labelName.length <= 10
                      ? tag.labelName
                      : `${tag.labelName.substring(0, 8)}...${tag.labelName.substring(
                          tag.labelName.length - 2
                        )}`}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <Button onClick={() => this.setState({ visible: true })}>选择</Button>
        )}

        {visible && (
          <Modal
            centered
            title={
              <div>
                选择标签<span>最多关联10个标签</span>
              </div>
            }
            wrapClassName="select-tag-modal-wrap"
            visible={visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <div className="select-tag">
              <div className="title">已选标签：</div>
              <div>
                {checkedValue.map(item => {
                  return (
                    <Tag closable onClose={e => this.onClose(item, e)} key={item.labelId}>
                      {item.labelName}
                    </Tag>
                  );
                })}
              </div>
            </div>
            <Tabs>
              {groupData.map(item => {
                return (
                  <TabPane tab={item.groupName} key={item.groupId}>
                    <div className="tag-group-content">
                      {item.list.length > 0 ? (
                        <>
                          {item.list.map(tag => {
                            return (
                              <div
                                key={tag.labelId}
                                className="tag-item"
                                className={
                                  this.checkedLabel(checkedValue, tag.labelId)
                                    ? 'tag-item checked'
                                    : 'tag-item'
                                }
                                onClick={() => this.onChecked(tag, item)}
                              >
                                {tag.labelName.length <= 10
                                  ? tag.labelName
                                  : `${tag.labelName.substring(0, 8)}...${tag.labelName.substring(
                                      tag.labelName.length - 2
                                    )}`}
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        <div className="no-empty">暂无标签</div>
                      )}
                    </div>
                  </TabPane>
                );
              })}
            </Tabs>
          </Modal>
        )}
      </div>
    );
  }
}

export default SelectTag;
